var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mostrarBtn)?_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.selecionarTodos()}}},[_vm._v("Selecionar Todos")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }